"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Divider = function Divider(props) {
  var id = props.id,
      className = props.className,
      style = props.style;

  var dividerClass = function dividerClass() {
    return (0, _classnames["default"])({
      'ui-divider': true
    }, className);
  };

  return /*#__PURE__*/_react["default"].createElement("hr", {
    id: id,
    style: style,
    className: dividerClass()
  });
};

Divider.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,

  /** className for reference */
  className: _propTypes["default"].string,

  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object
};
Divider.defaultProps = {
  className: '',
  id: '',
  style: {}
};
var _default = Divider;
exports["default"] = _default;